export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/bg.2570e76b.svg","height":3,"width":5,"blurWidth":0,"blurHeight":0};